var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.3125C4.65821 0.3125 0.3125 4.65821 0.3125 10C0.3125 15.3418 4.65821 19.6875 10 19.6875C15.3418 19.6875 19.6875 15.3418 19.6875 10C19.6875 4.6582 15.3418 0.3125 10 0.3125ZM2.1875 10C2.1875 5.69214 5.69214 2.1875 10 2.1875C11.8167 2.1875 13.4865 2.81612 14.8149 3.86013L3.86013 14.8148C2.81612 13.4864 2.1875 11.8167 2.1875 10ZM10 17.8125C8.18325 17.8125 6.51352 17.1839 5.18512 16.1399L16.1399 5.18512C17.1839 6.51352 17.8125 8.18325 17.8125 10C17.8125 14.3079 14.3079 17.8125 10 17.8125Z",
    fill: "#F05F31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBan);
export default __webpack_public_path__ + "static/media/ban.94c206a9.svg";
export { ForwardRef as ReactComponent };